export const ACTIVATE_PLUGIN = 'Plugins/activate';
